import React from "react";
import { Link } from "react-router-dom";
import "./SliderStyles.css";
import CategoryCarousel from "./categoryCarousal/CategoryCarousel";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const Categories = () => {
  return (
    <section className="relative py-16 bg-gradient-to-br from-cyan-50 via-blue-50 to-sky-50 overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-10 right-20 w-64 h-64 bg-[#0097b2] rounded-full mix-blend-multiply filter blur-3xl animate-blob"></div>
        <div className="absolute bottom-10 left-20 w-64 h-64 bg-[#134DA7] rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        <div className="flex justify-between items-end mb-6">
          <motion.h2
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="text-xl md:text-2xl font-semibold text-slate-800"
          >
            Explore Categories
          </motion.h2>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <Link to="/categories" className="group flex items-center gap-2 text-[#134DA7] font-semibold hover:text-[#0097b2] transition-colors">
              View all <ArrowRight size={18} className="transform transition-transform group-hover:translate-x-1" />
            </Link>
          </motion.div>
        </div>

        <div className="w-full">
          <CategoryCarousel />
        </div>
      </div>

      <style jsx>{`
        @keyframes blob {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
      `}</style>
    </section>
  );
};

export default Categories;
